import { Link } from 'react-router-dom';

const TikTokIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
        <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.69a8.18 8.18 0 0 0 4.78 1.52V6.75a4.85 4.85 0 0 1-1.01-.06z"/>
    </svg>
);

const InstagramIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
        <circle cx="12" cy="12" r="4"/>
        <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/>
    </svg>
);

const LinkedInIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
        <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6zM2 9h4v12H2z"/>
        <circle cx="4" cy="4" r="2"/>
    </svg>
);

export const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="bg-black" data-testid="footer">
            <div className="max-w-7xl mx-auto px-6 md:px-12 py-6">
                <div className="flex flex-col md:flex-row justify-between items-center gap-4">
                    {/* Logo */}
                    <Link to="/" className="flex flex-col items-start leading-none" data-testid="footer-logo">
                        <span className="font-black text-xl text-white tracking-tight">Catching</span>
                        <span className="font-black text-xl text-black tracking-tight bg-brand-lime rounded-full pl-8 pr-3 py-0.5 ml-8">on</span>
                    </Link>

                    {/* Inline nav links */}
                    <div className="flex items-center gap-8">
                        {['Home', 'About', 'Services', 'Contact'].map((link) => (
                            <Link
                                key={link}
                                to={link === 'Home' ? '/' : `/${link.toLowerCase()}`}
                                className="font-bold text-sm text-white/70 hover:text-brand-lime transition-colors"
                                data-testid={`footer-link-${link.toLowerCase()}`}
                            >
                                {link.toUpperCase()}
                            </Link>
                        ))}
                    </div>

                    {/* Social icons */}
                    <div className="flex items-center gap-4">
                        <a href="https://www.tiktok.com/@catchingoncomms?_t=ZG-8tDoQHjQAEq&_r=1" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-brand-lime transition-colors" aria-label="TikTok">
                            <TikTokIcon />
                        </a>
                        <a href="https://www.instagram.com/catchingoncomms/?hl=en" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-brand-lime transition-colors" aria-label="Instagram">
                            <InstagramIcon />
                        </a>
                        <a href="https://www.linkedin.com/company/catching-on" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-brand-lime transition-colors" aria-label="LinkedIn">
                            <LinkedInIcon />
                        </a>
                    </div>

                    {/* Privacy & Copyright */}
                    <div className="flex items-center gap-4 text-sm">
                        <Link to="/privacy" className="text-white/60 hover:text-brand-lime transition-colors font-bold">
                            Privacy Policy
                        </Link>
                        <Link to="/terms" className="text-white/60 hover:text-brand-lime transition-colors font-bold">
                            Terms
                        </Link>
                        <span className="text-white/40">© {currentYear} Catching On - Powered By Dockside Design</span>
                    </div>
                </div>
            </div>
        </footer>
    );
};
